import get from "lodash.get";

// Context
import { useContext } from "react";
import { ResourceContext } from "~/context/content";
import { FilterContext } from "~/context/resource-filter";

// Components
import PostListing from "~/components/resource/listing/post";
import CardListing from "~/components/resource/listing/card";
import GridListing from "~/components/resource/listing/grid";
import TextOnlyListing from "~/components/resource/listing/text-only";
import SidebarColumn from "~/components/layout/sidebar-column";
import Pagination from "~/components/pagination";
import Filter from "~/components/resource/filter";
import NoResults from "~/components/resource/filter/no-results";
import Blocks from "~/components/blocks";

// Constants
const HAS_SIDE_BAR = ["posts", "news", "events"];

const getEyebrowType = type => {
    const HAS_CONTENT_TYPE_EYEBROW = ["resources"];
    if (HAS_CONTENT_TYPE_EYEBROW.includes(type)) {
        return "type";
    } else {
        return "duration";
    }
};

export default ({ resources, paging }) => {
    const type = useContext(ResourceContext);
    const hasSidebar = HAS_SIDE_BAR.includes(type);

    const eyebrow = getEyebrowType(type);
    const modules = get(resources, "listing_page.acf.modules");
    const filterState = useContext(FilterContext);

    let isLoading = false;
    let filterResources = null;
    let noResults = false;

    if (filterState) {
        isLoading = filterState.isLoading;
        filterResources = filterState.resources;
        if (filterResources && !filterResources.length) noResults = true;
    }

    let actualResources = filterResources ? filterResources : resources;
    const isPaginated =
        (paging.totalPages > 1 && !filterResources) || noResults;

    return (
        <>
            {/* Render ACF modules, if a page is attached to this listing */}
            {modules && <Blocks blocks={modules} />}

            <SidebarColumn
                isPaginated={isPaginated}
                hasSidebar={hasSidebar}
                extend={{
                    transition: "opacity 0.15s ease",
                    willChange: "opacity",
                    extend: [
                        {
                            condition: isLoading,
                            style: {
                                opacity: 0.3
                            }
                        }
                    ]
                }}
            >
                {/* FILTER - shown on main resources listing and library listing */}
                {["resources"].includes(type) && <Filter /> || (resources.filter(e => e.type === 'podcasts').length > 0) && <Filter /> || (resources.filter(e => e.type === 'videos').length > 0) && <Filter /> || (resources.filter(e => e.type === 'casestudies').length > 0) && <Filter /> || (resources.filter(e => e.type === 'posts').length > 0) && <Filter />}

                {!noResults &&
                    renderListingType({
                        type,
                        resources: actualResources,
                        hasSidebar,
                        isPaginated,
                        eyebrow
                    })}

                {noResults && <NoResults />}
            </SidebarColumn>

            {!filterResources && <Pagination paging={paging} />}
        </>
    );
};

//render intro text component if type is glossary

const renderListingType = options => {
    switch (options.type) {
        case "glossary":
            return <TextOnlyListing {...options} />;

        case "whitepapers":
        case "infographics":
        case "ebooks":
        case "library":
            return <GridListing {...options} />;

        case "webinars":
        case "casestudies":
        case "tools":
        case "podcasts":
        case "resources":
        case "videos":
        case "revenueexchange":
            return <CardListing {...options} />;

        default:
            return <PostListing {...options} />;
    }
};
